import {ApiError} from "./types";

export default class CouldNotCreateTeamError extends ApiError {
    public team: string;

    constructor(json: any, team: string) {
        super(json.message, json.errorCode);
        this.team = team;
    }

}



// WEBPACK FOOTER //
// ./src/api/errors/CouldNotCreateTeamError.ts